import { SkillGroup } from '../../gigproApi/skillGroups'
import { createMarketGigsPath } from '../../routes/utils'

export function getConnectModuleProsLink(
  marketCity: { market: { state: string }; city: string },
  skill: SkillGroup,
  params?: string,
) {
  return (
    createMarketGigsPath(
      marketCity.market.state,
      marketCity,
      skill.gigsSlug ?? skill.slug,
    ) + `${params ? `?${params}` : ''}`
  )
}
